/*eslint-disable*/
import { BodyText, TitleText } from 'styling/Typography'
import { AIChatContainer, AIChatQuestion, AIChatResponse, AICurrentChat, AskAiButton, AskAiContainer } from 'pages/GlobalView/GlobalView.styled'
import { SmallAimIcon } from 'assets/icons/SmallAimIcon'
import { useEffect, useRef, useState } from 'react'
import { PaperPlaneIcon } from 'assets/icons/PaperPlaneIcon'
import { EventSource } from 'eventsource'
import { fetchAuthSession } from 'aws-amplify/auth'
import { ChatLoader } from 'pages/Shifts/Shifts.styled'
import { Button, Flex } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams } from 'utils/helpers'
import { IParsedShiftAssistantJson } from 'types/shifts.interface'
import { IShiftAssistantMessage, IShiftsAssistantMessageResponse } from 'types/api/shiftsApi.interface'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { getWorkSchedules } from 'features/work-schedules/workScheduleSlice'

export const ScheduleAiAssistant = ({ params }: { params: any }) => {
    const [open, setOpen] = useState(false)
    const inputRef = useRef(null)
    const [messages, setMessages] = useState<IShiftAssistantMessage[]>([]);
    const eventSourceRef = useRef(null);
    const chatRef = useRef(null)
    const containerRef = useRef(null)
    const [text, setText] = useState<string>('')
    const [isConnected, setIsConnected] = useState(false);
    const [events, setEvents] = useState([]);
    const [error, setError] = useState(null);
    const [url, setUrl] = useState(process.env.REACT_APP_API + '/shift/assistant/chat/message/stream?message=');
    const [chatId, setChatId] = useState(null)
    const dispatch = useDispatch<AppDispatch>()

    const processedMessagesRef = useRef(new Set())

    useEffect(() => {
        inputRef?.current?.focus()
    }, [open])

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages])

    useEffect(() => {
        const outSideClick = (e) => {
            if (!containerRef.current.contains(e.target)) {
                setOpen(false)
                setChatId(null)
                setMessages([])
                processedMessagesRef.current.clear()
            }
        }

        document.addEventListener('mousedown', outSideClick)

        return () => {
            document.removeEventListener('mousedown', outSideClick)
        }
    }, [])

    useEffect(() => {
        const message = messages[messages.length - 1];

        if (message?.type === 'answer' &&
            message?.shouldMarkMessageAsJSON &&
            message?.id &&
            !processedMessagesRef.current.has(message.id)) {

            try {
                const jsonPrefix = 'JSON';
                const startIndex = message.data.indexOf(jsonPrefix);

                if (startIndex !== -1) {
                    const jsonPart = message.data.split('JSON:');
                    const parsed: IParsedShiftAssistantJson = JSON.parse(jsonPart[1]);

                    if (parsed.type !== 'users_with_info') {
                        processedMessagesRef.current.add(message.id);
                        dispatch(getWorkSchedules(params));
                    }
                }
            } catch (err) {
                console.error('Error parsing JSON from message:', err);
            }
        }
    }, [messages, dispatch, params])

    const handleOpen = () => {
        setOpen(true)
    }

    const handleMessage = (q: string, a: IShiftsAssistantMessageResponse) => {
        if (q) {
            setMessages(prev => [...prev, { type: 'question', data: q, shouldMarkMessageAsJSON: a?.messageChunk.shouldMarkMessageAsJSON }])
        } else {
            setMessages(prev => {
                const copy = structuredClone(prev)
                if (a?.type == 2) {
                    const index = copy.findIndex((message) => message.type === 'answer' && message.id === a.messageChunk.id);
                    if (index > -1) {
                        copy[index].data = copy[index].data + a.messageChunk.chunk
                    } else {
                        copy.push({ type: 'answer', data: a.messageChunk.chunk, id: a.messageChunk.id, shouldMarkMessageAsJSON: a?.messageChunk.shouldMarkMessageAsJSON })
                    }
                } else {
                    setChatId(a.chat.id)
                }

                return copy
            })
        }
    }

    const handleConnect = async (txt?: string) => {
        try {
            if (eventSourceRef.current) {
                eventSourceRef.current.close();
            }

            const session = await fetchAuthSession()
            const eventSource = new EventSource((url + (txt ?? text)) + (chatId ? ('&chatId=' + chatId) : ''), {
                fetch: (input, init) =>
                    fetch(input, {
                        ...init,
                        headers: {
                            ...init.headers,
                            Authorization: `Bearer ${session.tokens.accessToken.toString()}`,
                        },
                    }),
            });
            eventSourceRef.current = eventSource;

            eventSource.onopen = () => {
                setIsConnected(true);
                setError(null);
                setEvents(prev => [...prev, { type: 'connection', data: 'Connection established', timestamp: new Date().toISOString() }]);
            };

            eventSource.onmessage = (event) => {
                handleMessage(null, JSON.parse(event.data))
            };

            eventSource.onerror = (err) => {
                setError(`Connection error: ${err.message || 'Unknown error'}`);
                setIsConnected(false);
                eventSource.close();
                eventSourceRef.current = null;
            };

        } catch (err) {
            setError(`Failed to connect: ${err.message}`);
        }
    };

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages])

    const handleSendMessage = async (txt?: string) => {
        if (text || txt) {
            (text.length || (txt && txt.length)) && await handleConnect(txt ?? null)
            handleMessage(txt ?? text, null)
            setText('')
        }
    }

    const parseJsonForDisplay = (text: string, latestMessage?: boolean) => {
        const jsonPrefix = 'JSON';
        const startIndex = text.indexOf(jsonPrefix);
        if (startIndex === -1) return null;
        const jsonPart = text.split('JSON:');

        try {
            const parsed: IParsedShiftAssistantJson = JSON.parse(jsonPart[1]);

            return parsed.type == 'users_with_info' ? <Flex column gap='1rem' >
                <Flex column gap='1rem' mb='16' >
                    {parsed.users.map(u => <Flex key={u.userId} gap='1rem' >
                        <BodyText weight='bold' >{u.firstName + ' ' + u.lastName}</BodyText>
                        <BodyText>{u.shiftName}</BodyText>
                        <BodyText>{formatDateForDisplay(u.date)}</BodyText>
                    </Flex>)}
                </Flex>
                {latestMessage && <Button onClick={() => handleSendMessage('I confirm this schedule')} orange>Confirm this schedule</Button>}
            </Flex> : <BodyText>{parsed.message}</BodyText>

        } catch (err) {
            return <></>;
        }
    }

    const handleDisconnect = async () => {
        if (eventSourceRef.current) {
            await eventSourceRef.current.close();
            eventSourceRef.current = null;
            setIsConnected(false);
            setEvents(prev => [...prev, { type: 'connection', data: 'Connection closed', timestamp: new Date().toISOString() }]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    };

    return (
        <AskAiContainer ref={containerRef} >
            <AIChatContainer darken open={open}>
                <AICurrentChat style={{ width: '100%' }} ref={chatRef} >
                    {messages.map((message, index) =>
                        message.type === 'question' ? <>
                            <AIChatQuestion key={index} className={message.type}>
                                <div className='content' >
                                    <BodyText dangerouslySetInnerHTML={{ __html: message.data.replace(/\n/g, '<br />') }} />
                                </div>
                            </AIChatQuestion>
                        </> : !message.shouldMarkMessageAsJSON ? <>
                            <AIChatResponse key={index} className={message.type}>
                                <BodyText>
                                    {message.data}
                                </BodyText>
                            </AIChatResponse>
                        </> : <>
                            {parseJsonForDisplay(message.data, index == messages.length - 1)}
                        </>
                    )}
                    {messages[messages.length - 1]?.type == 'question' && <Flex width='100%' ><ChatLoader /></Flex>}
                </AICurrentChat>
            </AIChatContainer>
            <AskAiButton width={open ? '800px' : '170px'} onClick={handleOpen}>
                {open ? (
                    <Flex width='100%' gap='1rem'   >
                        <input onKeyDown={handleKeyDown} onChange={e => setText(e.target.value)} value={text} onClick={e => e.stopPropagation()} ref={inputRef} placeholder='Ask AI' />
                        <PaperPlaneIcon onClick={() => text.length ? handleSendMessage() : null} />
                    </Flex>
                ) : (
                    <>
                        <TitleText style={{ marginRight: '10px' }} weight='bold'>
                            Ask
                        </TitleText>
                        <SmallAimIcon />
                    </>
                )}
            </AskAiButton>
        </AskAiContainer>
    )
}